<template>
    <transition name="fade">
        <div class="player-result-list fixed flex justify-center items-center w-full h-full p-4">
            <div class="backdrop absolute w-full h-full" @click="closeModal"></div>
            <div class="content-box flex flex-col p-4 w-full h-full">
                <div class="content-header flex justify-end">
                    <i
                        @click="closeModal"
                        class="fas fa-times text-ui-color text-xl shadow-text-none cursor-pointer"
                    ></i>
                </div>
                <div class="main-content p-0 md:pl-4 overflow-y-auto">
                    <div v-for="(item, index) in resultList" :key="index" class="player flex text-ui-color mb-2">
                        <span class="shadow-text-none">{{ index + 1 }}.</span>
                        <span class="uppercase shadow-text-none">{{ item.name }}</span>
                        <span class="shadow-text-none">{{ item.score }}/{{ result.questions.length }}</span>
                        <span class="shadow-text-none">{{ parseFloat(item.timer / 60).toFixed(2) }}</span>
                        <span class="shadow-text-none">min</span>
                    </div>
                    <div
                        v-if="result.score.length > 3 && !isPaidUser"
                        @click="showPaymentPopup"
                        class="player flex text-ui-color justify-center mt-5 underline cursor-pointer"
                    >
                        {{ $t('playlive_summary_upgrade_to_see_more') }}
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        result: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            orderAbility: 'orderAbility'
        }),

        isPaidUser() {
            return this.orderAbility.is_24hrs_access || this.orderAbility.has_subscribed
        },

        resultList() {
            if (!this.isPaidUser) {
                return this.result.score.slice(0, 3)
            } else {
                return this.result.score
            }
        }
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        showPaymentPopup() {
            this.$store.commit('openPaymentPopup', true)
            this.$store.commit('setTypeUpgradeModal', 'show-all-player')
        }
    }
}
</script>

<style lang="scss">
.player-result-list {
    top: 0;
    left: 0;
    z-index: 10;

    .backdrop {
        top: 0;
        left: 0;
        z-index: 1;
    }

    .text-ui-color {
        color: var(--button-text-color);
    }

    .content-box {
        row-gap: 1rem;
        max-width: 700px;
        max-height: 700px;
        background-color: var(--button-background-color);
        border-radius: 1rem;
        z-index: 2;

        @media screen and (max-width: 767px) {
            max-height: 80%;
        }

        .main-content {
            &::-webkit-scrollbar {
                width: 10px;

                @media screen and (max-width: 767px) {
                    width: 4px;
                }
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background-color: rgba(255, 255, 255, 0.2);

                @media screen and (max-width: 767px) {
                    border-radius: 4px;
                }
            }

            .player {
                font-size: 1.5rem;

                @media screen and (max-width: 767px) {
                    font-size: 0.875rem;
                }

                > span:first-child {
                    width: 10%;
                }

                > span:nth-child(2) {
                    width: 50%;
                }

                > span:nth-child(3) {
                    width: 20%;
                }

                > span:nth-child(4) {
                    width: 10%;
                }

                > span:last-child {
                    width: 10%;
                }
            }
        }
    }
}
</style>
